import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownPaymentType, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, MenuPaymentId, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiGetPaymentList, ApiDeletePayment, ApiCheckUserMenuAccess } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetPaymentType, GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import moment from "moment";
import AddButton from "components/Button/AddButton";
import ShowIcon from "assets/icon/ShowIcon";

export default function Payment(){
    let navigate = useNavigate()

    const { data: paymentList, fetch: getPaymentList } = useFetch(ApiGetPaymentList)
    const { fetch: deletePayment } = useFetch(ApiDeletePayment)
    const { fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)

    const [clientName, setCLientName] = useState(EmptyString)
    const [projectLocation, setProjectLocation] = useState(EmptyString)
    const [paymentType, setPaymentType] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [allowCreate, setAllowCreate] = useState(false)
    const [allowEdit, setAllowEdit] = useState(false)
    const [allowDelete, setAllowDelete] = useState(false)
    const [allowUndelete, setAllowUndelete] = useState(false)
    const [allowView, setAllowView] = useState(false)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const addBtnClick = () => {
        navigate("/company/payment-client/form?paymentId=&formType=" + FormTypeAdd)
    }

    useEffect(() => {
        setLoading({isOpen: true})

        fCheckUserAccess(localStorage.getItem("Id"), MenuPaymentId, localStorage.getItem("CompanyId")).then((res) => {
            if(!res.access){
                navigate("/access-denied")
            }
            if(res.create){
                setAllowCreate(true)
            }
            if(res.edit){
                setAllowEdit(true)
            }
            if(res.delete){
                setAllowDelete(true)
            }
            if(res.unDelete){
                setAllowUndelete(true)
            }
            if(res.view){
                setAllowView(true)
            }
            fBindGrid(0)
        })
    },[])

    // Function Button
    function fEditBtnClick(paymentId){
        navigate("/company/payment-client/form?paymentId=" + paymentId + "&formType=" + FormTypeEdit)
    }
    function fDeleteBtnClick(paymentId, status, projectId, paymentType){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    let stat

                    if (status === 1){
                        stat = 2
                    }else{
                        stat = 1
                    }

                    fDeletePayment(paymentId, stat, projectId, paymentType)
                    fBindGrid(pageIndex)
                }
            }
        })
    }
    function fSearchBtnClick(){
        fBindGrid(0)
    }
    const viewBtnClick = (paymentId) => {
        navigate("/company/payment-client/view?paymentId=" + paymentId + "&formType=" + FormTypeView)
    }

    // Function Api Call
    async function fGetPaymentList(index){
        let res

        await getPaymentList({
            data: {
                clientName: clientName,
                projectLocation: projectLocation, 
                paymentType: paymentType === EmptyString ? 0 : paymentType,
                companyId: localStorage.getItem("CompanyId"),
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeletePayment(paymentId, status, projectId, paymentType){
        await deletePayment({
            data: {
                paymentId: paymentId,
                status: status,
                projectId: projectId,
                paymentType: paymentType
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            fBindGrid(0)
        })
    }
    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
        
        await checkAccess({
            data: {
                userId: userId, 
                menuId: menuId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                access = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
        
        return access
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== EmptyString ? parseInt(index) : 0) : 0

        fGetPaymentList(i).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = Math.ceil(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i < numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    const enterKeyDown = (e) => {
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    const clientNameChange = (e) => {setCLientName(e.target.value)}
    const projectLocationChange = (e) => {setProjectLocation(e.target.value)}
    const paymentTypeChange = (e) => {setPaymentType(e.value)}
    const statusChange = (e) => {setStatus(e.value)}

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Payment Client</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full 2xl:w-72">
                        <span>Client Name</span>
                        <input className="input" value={clientName} onChange={clientNameChange} onKeyDown={enterKeyDown} />
                    </div>
                    <div className="flex flex-col gap-1 w-full 2xl:w-72">
                        <span>Project Location</span>
                        <input className="input" value={projectLocation} onChange={projectLocationChange} />
                    </div>
                    <div className="flex flex-col gap-1 w-full 2xl:w-72">
                        <span>Payment Type</span>
                        <Dropdown value={paymentType} options={DropdownPaymentType} onChange={paymentTypeChange} placeholder={"All"} />
                    </div>
                    <div className="flex flex-col gap-1 w-full 2xl:w-72">
                        <span>Status</span>
                        <Dropdown value={ status } options={DropdownStatusList} onChange={statusChange} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end sm:justify-start items-end h-full">
                        <SearchButton onClick={() => { fSearchBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className={`flex w-full justify-end ${allowCreate ? 'flex' : 'hidden'}`}>
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Client</th>
                            <th className="font-semibold text-left px-2">Project Location</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Payment Date</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Payment Type</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Amount</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { paymentList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.clientName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.projectLocation }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ moment(data.paymentDate).format("DD MMM yyyy") }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetPaymentType(data.paymentType) }</span>
                                    </td>
                                    <td className="pr-8 hidden text-right sm:table-cell">
                                        <span>Rp { money(data.amount) }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className={`button flex gap-2 ${allowView ? 'flex' : 'hidden'}`} onClick={() => viewBtnClick(data.paymentId)}>
                                            <ShowIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${allowEdit ? 'flex' : 'hidden'}`} onClick={() => fEditBtnClick( data.paymentId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === 1 ? (allowDelete ? 'flex' : 'hidden') : 'hidden' }`} onClick={() => fDeleteBtnClick( data.paymentId, data.status, data.projectId, data.paymentType)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === 1 ? 'hidden' : (allowUndelete ? 'flex' : 'hidden') }`} onClick={() => fDeleteBtnClick(data.paymentId, data.status, data.projectId, data.paymentType)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}